import { useEffect, useState } from 'react';

/**
 * Delays a rapidly changing value.
 *
 * Used by the student search so a fast typist makes one request rather than
 * one per keystroke.
 */
export function useDebounced<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
